const columns = [
  { name: "Aluno", value: "name", filter: true },
  { name: "Status", value: "status", filter: true },
  { name: "Nota", value: "score", filter: false },
];

function getName(status: any) {
  if (!status) return "Não iniciada";
  const statusNames = {
    ASSIGNED: "Aguardando Correção",
    OVERDUE: "Não enviado",
    FEEDBACK: "Corrigido",
  };
  return statusNames[status] || "Não iniciada";
}
function getIcon(status: any) {
  if (!status) return "bi-question-circle";
  const statusIcons = {
    ASSIGNED: "io-timer-sharp",
    OVERDUE: "bi-exclamation-lg",
    FEEDBACK: "bi-check-circle-fill",
  };
  return statusIcons[status] || "bi-question-circle";
}
function getClass(status: any) {
  if (!status) return "bg-gray-200 text-gray-700";
  const statusClasses = {
    ASSIGNED: "bg-h-primary-50 text-h-primary-500 flex items-center gap-1",
    OVERDUE: "bg-h-error-50 text-h-error-500 flex items-center gap-1",
    FEEDBACK: " bg-h-success-50 text-h-success-500 flex items-center gap-1",
  };
  return statusClasses[status] || "bg-gray-200 text-gray-700";
}
function getIconSize(status: any) {
  if (!status) return 1;
  const statusIconSizes = {
    OPEN: 1,
    OVERDUE: 1,
    FEEDBACK: 1,
  };
  return statusIconSizes[status] || 1;
}
function formatResponse(response: any) {
  return response.map((item: any) => ({
    ...item,
    status: {
      name: getName(item.status),
      class: getClass(item.status),
      icon: getIcon(item.status),
      iconSize: getIconSize(item.status),
      value: item.status,
    },
    studentName: item?.student?.name,
  }));
}

export { formatResponse, columns };
